// extracted by mini-css-extract-plugin
export default {"root":"PlasmicAddClientButton_root__k3I6x","text__q4ON3":"PlasmicAddClientButton_text__q4ON3__jSX3T","text__uztQu":"PlasmicAddClientButton_text__uztQu__vQqky"};